import { render } from "./TicketInstructions.vue?vue&type=template&id=f2b2a1e8"
import script from "./TicketInstructions.vue?vue&type=script&lang=js"
export * from "./TicketInstructions.vue?vue&type=script&lang=js"

import "./TicketInstructions.vue?vue&type=style&index=0&id=f2b2a1e8&lang=scss"

import exportComponent from "/codebuild/output/src4234632789/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__